import { styled } from 'linaria/react';

import { theme } from '../../Theme';

export default styled('main')`
  background: ${theme.colors.white};
  flex: 1 1 auto;
`;
